import {
    Box,
    Button,
    Checkbox, CircularProgress,
    Dialog, DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    Drawer,
    IconButton,
    Radio, Switch, TextField, ThemeProvider,
} from '@mui/material';
import {ezprOrange, useLocalStorage} from '../../_helpers';
import CloseIcon from '@mui/icons-material/Close';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import {Star, StarBorder} from '@mui/icons-material';
import {FilterView} from './FilterView.jsx';
import React, {useEffect, useState} from 'react';
import FavoriteFilters from '../../../models/cloudobjects/FavoriteFilters';
import PropTypes from 'prop-types';
import {Transaction, BrickContext} from 'olympe';
import {orangeTheme} from '../../_theme';
import {PurchaseRequest} from '../../../models/PurchaseRequest';
import {getAuthorizationDataLambda} from '../../../utils/functionSignatures';
import {styled} from '@mui/material/styles';
import {checkLabelValueObject} from '../../../utils/checkObjects';

export const defaultFilter = {
    allSelected: false,
    spenders: {
        selected: [],
        isInclude: true,
    },
    requesters: {
        selected: [],
        isInclude: true,
    },
    projectTitle: {
        selected: [],
        isInclude: true,
    },
    suppliers: {
        selected: [],
        isInclude: true,
    },
    categories: {
        selected: [],
        isInclude: true,
    },
    materials: {
        selected: [],
        isInclude: true,
    },
    ids: {
        selected: [],
        isInclude: true,
    },
    statuses: {
        selected: [],
        isInclude: true,
    },
    sources: {
        selected: [],
        isInclude: true,
    },
    wayOfBuying: {
        selected: [],
        isInclude: true,
    },
    companyCode: {
        selected: [],
        isInclude: true,
    },
    purchaseOrganization: {
        selected: [],
        isInclude: true,
    },
    purchasingGroup: {
        selected: [],
        isInclude: true,
    },
    defaultPlant: {
        selected: [],
        isInclude: true,
    },
    defaultStorageLocation: {
        selected: [],
        isInclude: true,
    },
    paymentTerms: {
        selected: [],
        isInclude: true,
    },
    supplierStatus: {
        selected: [],
        isInclude: true,
    },
    startCreationDate: {
        selected: [],
        isInclude: true,
    },
    endCreationDate: {
        selected: [],
        isInclude: true,
    },
    startRequestedDeliveryDate: {
        selected: [],
        isInclude: true,
    },
    endRequestedDeliveryDate: {
        selected: [],
        isInclude: true,
    },
    prNumber: {
        selected: [],
        isInclude: true,
    },
};

/**
 * @param {DrawerFiltersContent.propTypes} props
 * @return {Element}
 * @constructor
 */
export const DrawerFiltersContent = (props) => {
    const [selectedFilters, setSelectedFilters] = useLocalStorage('selectedFilters', defaultFilter);
    const [anchorEl, setAnchorEl] = useState(null);
    const [favFiltersHighlighted, setFavFiltersHighlighted] = useState(false);
    const [favFilters, setFavFilters] = useState([]);
    const [enabledFavFilter, setEnabledFavFilter] = useState('');
    const [editableName, setEditableName] = useState('');
    const [renameMode, setRenameMode] = useState(false);
    const [newName, setNewName] = useState('');
    const [enterNamePopupOpen, setEnterNamePopupOpen] = useState(false);
    const [nameValue, setNameValue] = useState('');
    const favFiltersOpen = Boolean(anchorEl);
    const [isLoadingAuthData, setIsLoadingAuthData] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState({});

    const showSwitch = props.currentTab === PurchaseRequest.tab.submitted || props.currentTab === PurchaseRequest.tab.open;

    useEffect(() => {
        FavoriteFilters.getMyFavoriteFilters(props.context, props.userId).then((result) => {
            setFavFilters(result);
        });
    }, [anchorEl]);

    const handleCloseEnterNamePopup = () => {
        setEnterNamePopupOpen(false);
        setNameValue('');
    };

    const handleSaveEnterNamePopup = () => {
        const transaction = Transaction.from(props.context);
        FavoriteFilters.createFromFilterObject(transaction, selectedFilters, props.userId, nameValue);
        Transaction.process(props.context, transaction)
            .then(() => {
                setFavFiltersHighlighted(true);
            })
            .catch((r) => {
                console.error('Error when creating a favorite filters' + r);
            })
            .finally(() => {
                setEnterNamePopupOpen(false);
                setNameValue('');
            });
    };

    const handleOpenFavFiltersMenu = (event) => {
        setAnchorEl(event.currentTarget);
        FavoriteFilters.getMyFavoriteFilters(props.context, props.userId).then((result) => {
            setFavFilters(result);
        });
    };
    const handleClickFavFilters = (favFilter) => {
        if (favFilter.filters) {
            setSelectedFilters(favFilter.filters);
            setEnabledFavFilter(favFilter.tag);
        }
        setAnchorEl(null);
        setRenameMode(false);
    };

    const handleChangeFavorite = (event) => {
        if (event.target.checked) {
            setEnterNamePopupOpen(true);
        }
    };

    const handleClickOnDeleteFavFilter = (event, favFilter) => {
        event.stopPropagation();
        const transaction = Transaction.from(props.context);
        transaction.delete(favFilter.tag);
        Transaction.process(props.context, transaction)
            .then(() => setFavFilters(favFilters.filter((f) => f.tag !== favFilter.tag)))
            .catch(console.error);
    };

    const handleClickOnRenameFavFilter = (event, favFilter) => {
        event.stopPropagation();
        if (renameMode) {
            const transaction = Transaction.from(props.context);
            transaction.update(favFilter.tag, FavoriteFilters.nameProp, newName);
            Transaction.process(props.context, transaction)
                .then(() => setRenameMode(!renameMode))
                .catch(console.error);
        } else {
            setEditableName(favFilter.tag);
            setTimeout(() => {
                document.getElementById('name' + favFilter.tag).select();
                // selectText('name' + favFilter.tag);
                setRenameMode(!renameMode);
            });
        }
    };

    const handleCloseDrawer = () => {
        setFavFiltersHighlighted(false);
        props.handleClose();
    };

    const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);

    const retrieveAuthorizationDataLambda = async (isAllFilters, initialLoad) => {
        setIsLoadingAuthData(true);
        await getAuthorizationDataLambda(props.context, props.getAuthData, props.userId, async (result) => {
            const parsedResult = JSON.parse(result);
            const allowedCompanyCodes = parsedResult
                .map((auth) => auth.company_code)
                .filter((n) => n);
            const allowedPurchaseOrgs = parsedResult
                .map((auth) => auth.purchase_organization)
                .filter((n) => n);
            const allowedPurchasingGroups = parsedResult
                .map((auth) => auth.purchasing_group)
                .filter((n) => n);
            const allowedPlants = parsedResult
                .map((auth) => auth.plant)
                .filter((n) => n);

            const companyCodes = [];
            const purchaseOrg = [];
            const purchasingGroup = [];
            const plant = [];

            // If user has access to all (*), do not add anything in the filters
            if (!(allowedCompanyCodes.some((cc) => cc === '*'))) {
                allowedCompanyCodes.forEach((cc) => companyCodes.push(checkLabelValueObject(cc)));
            }
            if (!(allowedPurchaseOrgs.some((cc) => cc === '*'))) {
                allowedPurchaseOrgs.forEach((cc) => purchaseOrg.push(checkLabelValueObject(cc)));
            }
            if (!(allowedPurchasingGroups.some((cc) => cc === '*'))) {
                allowedPurchasingGroups.forEach((cc) => purchasingGroup.push(checkLabelValueObject(cc)));
            }
            if (!(allowedPlants.some((cc) => cc === '*'))) {
                allowedPlants.forEach((cc) => plant.push(checkLabelValueObject(cc)));
            }

            if (!initialLoad) {
                setSelectedFilters({
                    ...selectedFilters,
                    companyCode: {
                        selected: companyCodes,
                        isInclude: true,
                    },
                    purchaseOrganization: {
                        selected: purchaseOrg,
                        isInclude: true,
                    },
                    purchasingGroup: {
                        selected: purchasingGroup,
                        isInclude: true,
                    },
                    defaultPlant: {
                        selected: plant,
                        isInclude: true,
                    },
                    allSelected: isAllFilters,
                });
            }
            setIsLoadingAuthData(false);
        },
        () => setIsLoadingAuthData(false));
    };

    useEffect(() => {
        // let's fill the user filtered options
        retrieveAuthorizationDataLambda(selectedFilters.allSelected, true);
    }, []);

    const handleSwitchChange = (event) => {
        const checked = event.target.checked;
        // If the toggle is set to "All requests", and the current tab is "Open Requests", we compare the authorization
        // data and the available data, and automatically set the authorized values in the filters
        if (checked) {
            retrieveAuthorizationDataLambda(checked, false);
        } else if (!checked && props.currentTab === PurchaseRequest.tab.open) {
            setSelectedFilters({
                ...selectedFilters,
                companyCode: {
                    selected: [],
                    isInclude: true,
                },
                purchaseOrganization: {
                    selected: [],
                    isInclude: true,
                },
                purchasingGroup: {
                    selected: [],
                    isInclude: true,
                },
                defaultPlant: {
                    selected: [],
                    isInclude: true,
                },
                allSelected: checked,
            });
        } else {
            setSelectedFilters({
                ...selectedFilters,
                allSelected: checked,
            });
        }
    };

    const OrangeButton = styled(Button)(({_}) => ({
        'color': '#FFF',
        'backgroundColor': ezprOrange,
        '&:hover': {
            backgroundColor: '#CE7A00',
        },
    }));

    return (
        <ThemeProvider theme={orangeTheme}>
            <Drawer
                anchor={'right'}
                open={props.open}
                onClose={handleCloseDrawer}
                sx={{
                    '& .MuiDrawer-paper': {
                        overflowY: 'auto',
                        maxHeight: '100vh',
                    },

                }}
            >
                <Box sx={{
                    width: 403,
                    height: 50,
                    paddingX: 2,
                    backgroundColor: ezprOrange,
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    <IconButton
                        color="primary"
                        aria-label="close"
                        component="span"
                        style={{color: 'white', outline: 'none', boxShadow: 'none'}}
                        onClick={handleCloseDrawer}
                    >
                        <CloseIcon/>
                    </IconButton>
                    <div className={'filters-drawer-favorite-filters-text-left'}>Filter</div>
                    <div className={'filters-drawer-favorite-filters-text-right'}
                        onClick={handleOpenFavFiltersMenu}>Favorite filters
                    </div>
                    <div className={'filters-drawer-favorite-filters-icon-container'}
                        onClick={handleOpenFavFiltersMenu}>
                        {favFiltersOpen ? (
                            <ExpandLessIcon className={'filters-drawer-favorite-filters-icon'} fontSize={'small'}/>) :
                            (<ExpandMoreIcon className={'filters-drawer-favorite-filters-icon'} fontSize={'small'}/>)}
                    </div>
                    <Menu
                        anchorEl={anchorEl}
                        open={favFiltersOpen}
                        onClose={handleClickFavFilters}
                    >
                        <div className={'filters-drawer-favorite-filters-menu-title'}>Favorite Filters</div>
                        <Divider/>
                        {favFilters.length === 0 ? (
                            <div className={'filters-drawer-favorite-filters-no-fav-filters'}>No favorite filters
                                created.</div>
                        ) : favFilters.map((favFilter) => (
                            <MenuItem onClick={() => handleClickFavFilters(favFilter)}
                                key={'favFilter_' + favFilter.tag} onKeyDown={(e) => e.stopPropagation()}>
                                <div className={'filters-drawer-favorite-filters-menu-item'}>
                                    <Radio checked={favFilter.tag === enabledFavFilter} size={'small'} disabled/>
                                    <div className={'filters-drawer-favorite-filters-menu-item-info'}>
                                        <input onInput={(e) => {
                                            setNewName(e.target.value);
                                        }}
                                        style={{border: 'none', backgroundColor: 'rgba(0,0,0,0)'}}
                                        id={'name' + favFilter.tag}
                                        disabled={favFilter.tag !== editableName}
                                        className={'filters-drawer-favorite-filters-menu-item-name'}
                                        defaultValue={favFilter.metadata.name}
                                        onClick={(e) => {
                                            if (renameMode) {
                                                e.stopPropagation();
                                            }
                                        }}>
                                        </input>
                                        <div className={'filters-drawer-favorite-filters-menu-item-date'}>{
                                            `${padL(favFilter.metadata.creationDate.getDate())} ${
                                                favFilter.metadata.creationDate.toLocaleString('en-US', {month: 'long'})} ${
                                                favFilter.metadata.creationDate.getFullYear()} ${
                                                padL(favFilter.metadata.creationDate.getHours())}:${
                                                padL(favFilter.metadata.creationDate.getMinutes())}:${
                                                padL(favFilter.metadata.creationDate.getSeconds())}`
                                        }</div>
                                    </div>
                                    <Button
                                        className={'filters-drawer-favorite-filters-menu-rename'}
                                        variant={'text'}
                                        size={'small'}
                                        onClick={(e) => handleClickOnRenameFavFilter(e, favFilter)}>{renameMode && (favFilter.tag === editableName) ? 'Save' : 'Rename'}</Button>
                                    <IconButton
                                        component="span"
                                        size={'small'}
                                        onClick={(e) => handleClickOnDeleteFavFilter(e, favFilter)}
                                    >
                                        <DeleteIcon/>
                                    </IconButton>
                                </div>
                            </MenuItem>
                        ))}
                    </Menu>
                    <Checkbox className={'filters-drawer-favorite-filters-icon'}
                        checked={favFiltersHighlighted}
                        icon={<StarBorder/>}
                        checkedIcon={<Star/>}
                        size={'small'}
                        onChange={handleChangeFavorite}/>
                </Box>
                <div className='button-switch-container'>
                    <div></div>
                    {showSwitch && (
                        <div style={{display: 'flex', marginRight: '1rem', marginTop: '1rem'}}>
                            {isLoadingAuthData && (
                                <div style={{margin: '10px 10px 0 0'}}><CircularProgress size={20}/></div>)}
                            <div style={{
                                marginTop: '10px',
                                color: !selectedFilters.allSelected ? ezprOrange : '#000',
                            }}>My requests
                            </div>
                            <Switch
                                data-cy={'all-requests-switch'}
                                checked={selectedFilters.allSelected}
                                onChange={handleSwitchChange}
                            />
                            <div
                                data-cy={'all-requests-label'}
                                style={{
                                    marginTop: '10px',
                                    color: selectedFilters.allSelected ? ezprOrange : '#000',
                                }}
                            >All
                            </div>
                        </div>
                    )}
                </div>
                <FilterView
                    selectedFilters={selectedFilters}
                    setSelectedFilters={setSelectedFilters}
                    forwardEvent={props.forwardEvent}
                    setFilters={(newFilters) => {
                        setFavFiltersHighlighted(false);
                        props.setFilters(newFilters);
                    }}
                    handleClose={handleCloseDrawer}
                    currentTab={props.currentTab}
                    getAuthData={props.getAuthData}
                    context={props.context}
                    userId={props.userId}
                    getFiltersDropdownsOptions={props.getFiltersDropdownsOptions}
                    isLoadingAuthData={isLoadingAuthData}
                    filteredOptions={filteredOptions}/>
                <Box sx={{
                    display: 'flex',
                    alignSelf: 'end',
                    alignItems: 'center',
                    justifyItems: 'center',
                    gap: '10px',
                    marginBottom: '10px',
                    marginRight: '1rem',
                    marginTop: '1rem',
                }}>
                    <Button
                        sx={{color: '#656565'}}
                        variant={'text'}
                        onClick={async () => {
                            setSelectedFilters(defaultFilter);
                            setTimeout(() => {
                                props.forwardEvent();
                                props.handleClose();
                            }, 0);
                        }}
                    >
                        Reset
                    </Button>
                    <OrangeButton
                        variant={'contained'}
                        disabled={isLoadingAuthData}
                        onClick={() => {
                            // check if filter is all
                            const myRequestOnly = selectedFilters.allSelected;
                            if (myRequestOnly !== null && myRequestOnly === true ) {
                                const fields = ['companyCode', 'purchaseOrganization', 'purchasingGroup', 'defaultPlant'];
                                const tmpSelectedFilters = structuredClone(selectedFilters);
                                let updateSelectedFilters = false;
                                fields.forEach((item) => {
                                    if (tmpSelectedFilters[item].selected.length === 0 && filteredOptions[item]?.length > 0) {
                                        tmpSelectedFilters[item].selected = [...filteredOptions[item]];
                                        updateSelectedFilters = true;
                                    }
                                });
                                if (updateSelectedFilters) {
                                    setSelectedFilters(tmpSelectedFilters);
                                }
                            }
                            setTimeout(() => {
                                props.forwardEvent();
                                props.handleClose();
                            }, 0);
                        }}
                    >
                        Apply
                    </OrangeButton>
                </Box>
                <Dialog
                    sx={{position: 'absolute', left: 'unset', right: 0, bottom: 'unset', top: '40px', width: '430px'}}
                    open={enterNamePopupOpen}
                    onClose={handleCloseEnterNamePopup}>
                    <DialogContent>
                        <DialogContentText>
                            Please enter a name for your new favorite filters:
                        </DialogContentText>
                        <TextField
                            autoFocus
                            fullWidth
                            variant={'standard'}
                            margin={'dense'}
                            label={'Name'}
                            value={nameValue}
                            onChange={(e) => setNameValue(e.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseEnterNamePopup}>Cancel</Button>
                        <Button onClick={handleSaveEnterNamePopup}>Ok</Button>
                    </DialogActions>
                </Dialog>
            </Drawer>
        </ThemeProvider>
    );
};

DrawerFiltersContent.propTypes = {
    filters: PropTypes.object,
    forwardEvent: PropTypes.func,
    setFilters: PropTypes.func,
    handleClose: PropTypes.func,
    currentTab: PropTypes.string,
    context: PropTypes.instanceOf(BrickContext).isRequired,
    open: PropTypes.bool,
    userId: PropTypes.string,
    getAuthData: PropTypes.object,
    getFiltersDropdownsOptions: PropTypes.object,
};
